import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Faqs } from 'components/Faqs';
import { faqData } from 'sections/Resources/FreightTemplates/data';
import styles from 'sections/Resources/FreightTemplates/components/SectionFaq/SectionFaq.module.scss';

const cn = classNames.bind(styles);

const SectionFaq = (): ReactElement => {
  return (
    <section className={cn('faq')}>
      <div className={cn('container')}>
        <h2 className={cn('faq__title')}>Related FAQs</h2>
        <div className={cn('faq__list-container')}>
          <Faqs faqsData={faqData} />
        </div>
      </div>
    </section>
  );
};

export default SectionFaq;